import Accordion from '@/common/components/Accordion'
import { SpecialEntriesData } from '@/features/companies/types/companies.type'
import { ModalCreateSpecialEntry } from '@/features/privateCompanies/components/SpecialEntries/ModalCreateSpecialEntry'
import { SpecialEntryItem } from '@/features/privateCompanies/components/SpecialEntries/SpecialEntryItem'

interface SpecialEntriesProps {
  specialEntries?: SpecialEntriesData[]
  companyType?: string
  disabled?: boolean
  operationKlassToCheckPermission?: string
}

export const SpecialEntries = ({ specialEntries, companyType, disabled, operationKlassToCheckPermission }: SpecialEntriesProps) => {
  return (
    <Accordion
      className="py-1"
      contentClassName="data-[state=open]:overflow-visible"
      head={<p className="font-bold text-lg">Tarifas especiais</p>}
      body={
        <div className="flex flex-col gap-4">
          <ModalCreateSpecialEntry operationKlassToCheckPermission={operationKlassToCheckPermission} companyType={companyType} />

          {specialEntries?.map((specialEntry) => (
            <SpecialEntryItem key={specialEntry.id} specialEntry={specialEntry} disabled={disabled} />
          ))}
        </div>
      }
    />
  )
}
